<template>
  <v-container fluid class="pa-0">
    <!---------->
    <toolbar
      ref="toolbar"
      :items="datatableItems"
      @alert="openAlertDialog"
      @search="search"
      @adv-search="advancedSearch"
      @clear-search="clearSearch"
    />
    <datatable
      :search="searchObject"
      @items="getDatatableItems"
      @actions="openActionsDialog"
      @details="openDetailsDialog"
      @movement="openMovementDialog"
      @images="openImagesCarousel"
      @show-notes="openNotesDialog"
      @qr="openQrDialog"
    />
    <movement-dialog ref="movementDialog" />
    <qr-dialog ref="qrDialog" />
    <img-carousel ref="imgCarousel" />
    <details-dialog
      ref="detailsDialog"
      @close="''"
      @delete-applicability="getParts"
    />
    <actions-dialog ref="actionsDialog" @close="getParts" />
    <alert-dialog ref="alertDialog" />
    <notes-dialog ref="notesDialog" />
  </v-container>
</template>

<script>
import Datatable from "@/components/LostParts/datatable.vue";
import Toolbar from "@/components/LostParts/toolbar.vue";
import ActionsDialog from "@/components/LostParts/actionsDialog.vue";
import NotesDialog from "@/components/notesDialog.vue";
import AlertDialog from "@/components/alertDialog.vue";
import DetailsDialog from "@/components/detailsDialog.vue";
import MovementDialog from "@/components/movementDialog.vue";
import ImgCarousel from "@/components/imgCarousel.vue";
import QrDialog from "@/components/qrDialog.vue";

export default {
  components: {
    datatable: Datatable,
    toolbar: Toolbar,
    // 'edit-dialog': EditDialog,
    "actions-dialog": ActionsDialog,
    "alert-dialog": AlertDialog,
    "details-dialog": DetailsDialog,
    "movement-dialog": MovementDialog,
    // 'id-changer': IdChanger,
    // 'img-dialog': ImgDialog,
    "img-carousel": ImgCarousel,
    "qr-dialog": QrDialog,
    "notes-dialog": NotesDialog,
  },
  data: () => ({
    hideEditDialog: false,
    searchObject: {
      type: null,
      data: {},
    },
    datatableItems: [],
  }),
  mounted() {
    const { id } = this.$route.query;

    if (id) {
      const { toolbar } = this.$refs;
      toolbar.setId(id);
      toolbar.searchMethod();
    }
  },
  methods: {
    getParts() {
      // Fired when closing edit and actions dialog.
      if (this.searchObject.type === null) {
        this.clearSearch();
      } else if (this.searchObject.type === "regularSearch") {
        this.search(this.searchObject.data);
      } else if (this.searchObject.type === "advancedSearch") {
        this.advancedSearch(this.searchObject.data);
      }
    },
    /* Search ------------------------ */
    search(data) {
      this.searchObject = {
        type: "regularSearch",
        data,
      };
    },
    advancedSearch(data) {
      this.searchObject = {
        type: "advancedSearch",
        data,
      };
    },
    clearSearch() {
      this.searchObject = {
        type: null,
        data: {},
      };
    },
    /* Datatable Items --------------- */
    getDatatableItems(data) {
      this.datatableItems = data;
    },
    /* Details Dialog ------------------- */
    openDetailsDialog(data) {
      const { detailsDialog } = this.$refs;
      detailsDialog.open(data);
    },
    /* Actions Dialog ------------------- */
    openActionsDialog(data) {
      const { actionsDialog } = this.$refs;
      actionsDialog.open(data);
    },
    openMovementDialog(data) {
      const { movementDialog } = this.$refs;
      movementDialog.open(data);
    },
    /* Img Carousel ------------------ */
    openImagesCarousel(data) {
      const { imgCarousel } = this.$refs;
      imgCarousel.open(data);
    },
    /* QR Dialog --------------------- */
    openQrDialog(data) {
      const { qrDialog } = this.$refs;
      qrDialog.open(data);
    },
    /* Alert dialog ----------------------------------------------------------------------------- */
    openAlertDialog(data) {
      const { alertDialog } = this.$refs;
      alertDialog.open(data);
    },
    /* Notes dialog ----------------------------------------------------------------------------- */
    openNotesDialog(notes) {
      const { notesDialog } = this.$refs;
      notesDialog.open(notes);
    },
  },
};
</script>
